/* Atyab Premium — interactions d'interface (menu, tiroirs, recherche, révélations)
   Vanilla JS, aucune dépendance externe. */
(function () {
  'use strict';

  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  /* ---------- Tiroirs génériques ---------- */
  var Drawer = {
    lastFocus: null,
    open: function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      Drawer.lastFocus = document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('at-no-scroll');
      var first = el.querySelector('[data-drawer-focus]') || el.querySelector(focusableSelector);
      if (first) window.requestAnimationFrame(function () { first.focus(); });
      document.dispatchEvent(new CustomEvent('atyab:drawer:open', { detail: { id: id } }));
    },
    close: function (el) {
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('.at-drawer.is-open')) document.body.classList.remove('at-no-scroll');
      if (Drawer.lastFocus && document.contains(Drawer.lastFocus)) Drawer.lastFocus.focus();
    },
    closeAll: function () {
      document.querySelectorAll('.at-drawer.is-open').forEach(Drawer.close);
    }
  };
  window.AtyabDrawer = Drawer;

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      Drawer.open(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      Drawer.close(closer.closest('.at-drawer'));
      return;
    }
    if (event.target.classList && event.target.classList.contains('at-drawer__overlay')) {
      Drawer.close(event.target.closest('.at-drawer'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var open = document.querySelector('.at-drawer.is-open');
      if (open) { Drawer.close(open); return; }
      var nav = document.querySelector('.at-nav__item.is-open');
      if (nav) closeNavItem(nav);
    }
    if (event.key !== 'Tab') return;
    var drawer = document.querySelector('.at-drawer.is-open');
    if (!drawer) return;
    var items = Array.prototype.filter.call(drawer.querySelectorAll(focusableSelector), function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  /* ---------- Navigation desktop ---------- */
  function closeNavItem(item) {
    item.classList.remove('is-open');
    var trigger = item.querySelector('.at-nav__link');
    if (trigger && trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
  }

  function initNav() {
    var items = document.querySelectorAll('.at-nav__item--has-panel');
    items.forEach(function (item) {
      var trigger = item.querySelector('.at-nav__link');
      if (!trigger) return;
      var closeTimer;
      var openIt = function () {
        window.clearTimeout(closeTimer);
        items.forEach(function (other) { if (other !== item) closeNavItem(other); });
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      };
      var closeIt = function (delay) {
        closeTimer = window.setTimeout(function () { closeNavItem(item); }, delay || 0);
      };
      item.addEventListener('mouseenter', openIt);
      item.addEventListener('mouseleave', function () { closeIt(120); });
      item.addEventListener('focusin', openIt);
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) closeNavItem(item);
      });
      trigger.addEventListener('click', function (event) {
        if (trigger.tagName === 'BUTTON') {
          event.preventDefault();
          if (item.classList.contains('is-open')) closeNavItem(item); else openIt();
        }
      });
    });
  }

  /* ---------- Barre d'annonces ---------- */
  function initAnnouncement() {
    document.querySelectorAll('[data-announcement]').forEach(function (bar) {
      var items = bar.querySelectorAll('.at-announcement__item');
      if (items.length < 2) return;
      var delay = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
      var index = 0;
      window.setInterval(function () {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, delay);
    });
  }

  /* ---------- Révélations au défilement ---------- */
  function initReveal() {
    var targets = document.querySelectorAll('.at-reveal');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Recherche prédictive ---------- */
  function initPredictiveSearch() {
    document.querySelectorAll('[data-predictive-search]').forEach(function (form) {
      var input = form.querySelector('input[type="search"]');
      var results = form.parentElement.querySelector('[data-predictive-results]');
      if (!input || !results) return;
      var timer;
      var controller;
      input.addEventListener('input', function () {
        window.clearTimeout(timer);
        var term = input.value.trim();
        if (term.length < 2) { results.innerHTML = ''; return; }
        timer = window.setTimeout(function () {
          if (controller) controller.abort();
          controller = new AbortController();
          var url = (window.AtyabTheme.routes.predictive_search_url || '/search/suggest') +
            '?q=' + encodeURIComponent(term) +
            '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';
          fetch(url, { signal: controller.signal })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var next = doc.querySelector('[data-predictive-results]');
              results.innerHTML = next ? next.innerHTML : '';
            })
            .catch(function () { /* requête annulée */ });
        }, 250);
      });
    });
  }

  /* ---------- Sticky add-to-cart ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(anchor);
  }

  /* ---------- Filtres de collection / recherche (Search & Discovery) ----------
     Les filtres restent gérés côté Shopify (aucun catalogue téléchargé côté
     client) : on ne fait qu'appeler la Section Rendering API sur la section
     courante pour ne remplacer que les zones nécessaires (résultats, barre
     d'outils, panneaux de filtres desktop et tiroir mobile), sans recharger
     toute la page ni fermer le tiroir. Debounce + AbortController évitent les
     requêtes concurrentes lors d'une sélection rapide de plusieurs filtres. */
  function initFacets() {
    /* Les écouteurs sont délégués sur document et ne doivent être posés
       qu'une seule fois : initFacets() est ré-appelée à chaque
       "shopify:section:load" (éditeur de thème) et ne doit pas empiler des
       écouteurs supplémentaires à chaque re-rendu de section. */
    if (window.__atyabFacetsBound) return;
    window.__atyabFacetsBound = true;

    var activeController = null;
    var debounceTimer = null;

    function resultsRegion() {
      return document.querySelector('[data-facets-results]');
    }

    /* La Section Rendering API attend l'identifiant réel de la section, tel
       que Shopify le génère pour le modèle en cours (ex.
       "template--31103481020759__main"), et non le nom du fichier de section.
       On le lit sur le conteneur <div id="shopify-section-…"> qui entoure les
       résultats : cela fonctionne aussi bien pour la page collection que pour
       la page de recherche, sans rien coder en dur. Si l'identifiant est
       introuvable, on laisse la navigation normale se faire. */
    function sectionId() {
      var region = resultsRegion();
      var host = region && region.closest('[id^="shopify-section-"]');
      return host ? host.id.replace('shopify-section-', '') : null;
    }

    function setLoading(isLoading) {
      var region = resultsRegion();
      if (region) region.classList.toggle('at-loading', isLoading);
      document.querySelectorAll('[data-facets-form]').forEach(function (form) {
        form.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      });
    }

    function swapRegion(doc, selector) {
      var incoming = doc.querySelector(selector);
      var current = document.querySelector(selector);
      if (!incoming || !current) return false;
      current.innerHTML = incoming.innerHTML;
      return true;
    }

    /* --- Conservation de l'état d'interface des panneaux de filtres ---
       Le panneau (barre latérale desktop ou corps du tiroir mobile) est
       remplacé par la version rendue par Shopify à chaque application de
       filtre : c'est ce qui garantit des compteurs et des valeurs disponibles
       toujours exacts. Sans précaution, ce remplacement replierait les groupes
       ouverts, remonterait le panneau tout en haut et ferait perdre le focus.
       On relève donc cet état juste avant, puis on le réapplique juste après. */
    function escapeAttr(value) {
      return String(value).replace(/(["\\])/g, '\\$1');
    }

    /* Sélecteur permettant de retrouver, dans le panneau reconstruit,
       le champ qui avait le focus (case cochée, champ prix, tri…). */
    function focusSelector(el) {
      if (!el || el === document.body || !el.closest) return null;
      if (!el.closest('[data-facets-panel], [data-facets-form]')) return null;
      if (el.id) return '[id="' + escapeAttr(el.id) + '"]';
      var name = el.getAttribute && el.getAttribute('name');
      if (!name) return null;
      var selector = '[name="' + escapeAttr(name) + '"]';
      if (el.type === 'checkbox' || el.type === 'radio') {
        selector += '[value="' + escapeAttr(el.value) + '"]';
      }
      return selector;
    }

    function capturePanels() {
      var snapshots = [];
      document.querySelectorAll('[data-facets-panel]').forEach(function (panel) {
        var open = {};
        panel.querySelectorAll('details[data-facet-key]').forEach(function (details) {
          open[details.getAttribute('data-facet-key')] = details.open;
        });
        snapshots.push({ panel: panel, scrollTop: panel.scrollTop, open: open });
      });
      return { panels: snapshots, focus: focusSelector(document.activeElement) };
    }

    function restorePanels(state) {
      state.panels.forEach(function (snapshot) {
        var panel = snapshot.panel;
        if (!panel.isConnected) return;
        panel.querySelectorAll('details[data-facet-key]').forEach(function (details) {
          var key = details.getAttribute('data-facet-key');
          if (Object.prototype.hasOwnProperty.call(snapshot.open, key)) {
            details.open = snapshot.open[key];
          }
        });
        panel.scrollTop = snapshot.scrollTop;
      });

      if (!state.focus) return;
      var target = document.querySelector('[data-facets-panel] ' + state.focus) ||
        document.querySelector('[data-facets-form] ' + state.focus);
      if (target && typeof target.focus === 'function') {
        try { target.focus({ preventScroll: true }); } catch (error) { target.focus(); }
      }
    }

    function applyResponse(html, urlForHistory) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var uiState = capturePanels();

      swapRegion(doc, '[data-facets-results]');
      /* La barre d'outils contient le compteur de résultats ET le formulaire
         de tri, lequel réémet les filtres actifs dans des champs cachés :
         sans ce remplacement, changer le tri après un filtrage AJAX renverrait
         les filtres de la page initiale et les effacerait. */
      if (!swapRegion(doc, '[data-facets-toolbar]')) {
        swapRegion(doc, '[data-results-count]');
      }
      swapRegion(doc, '[data-facets-panel="desktop"]');
      swapRegion(doc, '[data-facets-panel="mobile"]');

      restorePanels(uiState);

      if (urlForHistory && window.history.pushState) {
        window.history.pushState({ atyabFacets: true }, '', urlForHistory);
      }

      document.dispatchEvent(new CustomEvent('atyab:section:rendered'));
      document.dispatchEvent(new CustomEvent('atyab:facets:updated'));
    }

    function requestUpdate(url, options) {
      var pushHistory = !options || options.pushHistory !== false;
      var section = sectionId();
      if (!section) { window.location.href = url; return; }
      if (activeController) activeController.abort();
      activeController = new AbortController();
      var controller = activeController;
      var separator = url.indexOf('?') > -1 ? '&' : '?';
      var fetchUrl = url + separator + 'section_id=' + encodeURIComponent(section);

      setLoading(true);
      fetch(fetchUrl, { signal: controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) {
          if (!response.ok) throw new Error('facets_http_error');
          return response.text();
        })
        .then(function (html) { applyResponse(html, pushHistory ? url : null); })
        .catch(function (error) {
          if (error.name === 'AbortError') return; // requête remplacée par une plus récente : rien à faire
          window.location.href = url; // repli : navigation normale si l'AJAX échoue
        })
        .finally(function () {
          if (controller === activeController) setLoading(false);
        });
    }

    function buildUrl(form) {
      var params = new URLSearchParams(new FormData(form));
      var base = form.getAttribute('action') || window.location.pathname;
      var query = params.toString();
      return query ? base + '?' + query : base;
    }

    /* Cases à cocher, tri : léger debounce pour absorber une sélection rapide */
    document.addEventListener('change', function (event) {
      var control = event.target.closest('[data-facets-form] [data-auto-submit]');
      if (!control) return;
      event.preventDefault();
      var form = control.closest('form');
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () { requestUpdate(buildUrl(form)); }, 300);
    });

    /* Filtre prix ("Appliquer") + repli noscript */
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-facets-form]');
      if (!form) return;
      event.preventDefault();
      window.clearTimeout(debounceTimer);
      requestUpdate(buildUrl(form));
    });

    /* Retrait d'un filtre actif / "Effacer les filtres" */
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-facets-form] a[href]');
      if (!link) return;
      event.preventDefault();
      window.clearTimeout(debounceTimer);
      requestUpdate(link.getAttribute('href'));
    });

    /* Bouton précédent/suivant du navigateur : on resynchronise le contenu
       sans repousser d'entrée d'historique (déjà en place). */
    window.addEventListener('popstate', function () {
      if (!resultsRegion()) return;
      window.clearTimeout(debounceTimer);
      requestUpdate(window.location.href, { pushHistory: false });
    });
  }

  function init() {
    initNav();
    initAnnouncement();
    initReveal();
    initPredictiveSearch();
    initStickyAtc();
    initFacets();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Ré-initialisation après un rendu de section dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('atyab:section:rendered', initReveal);
})();
